import { defaultFeeEstimator } from "./defaults/feeEstimator.js";
import { defaultGasEstimator } from "./defaults/gasEstimator.js";
import { defaultPaymasterAndData } from "./defaults/paymasterAndData.js";
import { defaultUserOpSigner } from "./defaults/userOpSigner.js";
import { noopMiddleware } from "./noopMiddleware.js";
export const middlewareActions = (overrides) => (client) => ({
    middleware: {
        customMiddleware: overrides.customMiddleware ?? noopMiddleware,
        dummyPaymasterAndData: overrides.paymasterAndData?.dummyPaymasterAndData
            ? async (struct, { account }) => account.getEntryPoint().version === "0.6.0"
                ? {
                    ...struct,
                    paymasterAndData: overrides.paymasterAndData.dummyPaymasterAndData(),
                }
                : struct
            : defaultPaymasterAndData,
        feeEstimator: overrides.feeEstimator ?? defaultFeeEstimator(client),
        gasEstimator: overrides.gasEstimator ?? defaultGasEstimator(client),
        paymasterAndData: overrides.paymasterAndData?.paymasterAndData ?? defaultPaymasterAndData,
        userOperationSimulator: overrides.userOperationSimulator ?? noopMiddleware,
        signUserOperation: overrides.signUserOperation ?? defaultUserOpSigner,
    },
});
//# sourceMappingURL=actions.js.map